import { render, staticRenderFns } from "./StandartForm.vue?vue&type=template&id=0f177100&"
import script from "./StandartForm.vue?vue&type=script&lang=js&"
export * from "./StandartForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports